'use client';

import { type ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import { CookieBanner } from './CookieBanner';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
import { PublicHeader } from './PublicHeader';
import { PublicSearchToolbar } from './PublicSearchToolbar';

export const PublicLayout = ({ children }: { children: ReactNode }) => {
  const pathname = usePathname();
  const isProviderRatesPage = /^\/providers\/[^/]+\/rates\/?$/.test(pathname);

  return (
    <div className="public-layout flex min-h-dvh flex-col bg-[var(--ra-light-bg)]">
      <ScrollToTop />
      <PublicHeader />
      <main className={isProviderRatesPage ? 'flex flex-1 flex-col' : 'flex-1'}>
        <PublicSearchToolbar />
        {children}
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
};
